import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import './styles.css';

import { enableFixtures, fixturesRequested } from './modeller/api';

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

/* Development fixtures, if a dev build explicitly asked for them. Awaited
   before the first render so no screen briefly shows live data and then swaps.
   In a production build `fixturesRequested()` is a compile-time `false` and
   the fixture chunk does not exist to load. */
if (fixturesRequested()) await enableFixtures();

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
